import React, { memo } from 'react'
import { useState } from "react"
import { CaretRightOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';

import InfoModal from "../components/InfoModal"
const { Panel } = Collapse;

const Wethoughtyoumighthavequestions = ({ data, title }) => {

    const [isModalVisible, setIsModalVisible] = useState(false)
    const showModal = () => {
        setIsModalVisible(true)
    }

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const handleCancel = () => {
        setIsModalVisible(false)
    }

    return (
        <div className="Wethoughtyoumighthavequestions">
            <h1>{title}</h1>
            <Collapse
                bordered={false}
                defaultActiveKey={['-1']}
                style={{position:"relative"}}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} style={{position:'absolute', left:"0",top:'50%',transform: 'translate(0%, -50%)'}}/>}
                className="site-collapse-custom-collapse"
            >
                {data.map((q, index) => {
                    return (
                        <Panel key={index} header={q.question} className="site-collapse-custom-panel">
                            <p style={{ paddingRight: "10%" }}>{q.answer}</p>
                            {(() => {
                                const raw = [q.answer1, q.answer2, q.answer3, q.answer4, q.answer5, q.answer6, q.answer7, q.answer8, q.answer9]
                                const blocks = []
                                let bullets = []
                                raw.forEach((item, i) => {
                                    const isLast = i === raw.length - 1
                                    if (!item || item === "") {
                                        if (bullets.length) { blocks.push({ type: 'ul', items: [...bullets] }); bullets = [] }
                                        return
                                    }
                                    if (item === "sharerequirment") {
                                        if (bullets.length) { blocks.push({ type: 'ul', items: [...bullets] }); bullets = [] }
                                        blocks.push({ type: 'cta' })
                                    } else if (item.startsWith("- ")) {
                                        bullets.push(item.slice(2))
                                        if (isLast && bullets.length) { blocks.push({ type: 'ul', items: [...bullets] }); bullets = [] }
                                    } else {
                                        if (bullets.length) { blocks.push({ type: 'ul', items: [...bullets] }); bullets = [] }
                                        blocks.push({ type: 'p', text: item })
                                    }
                                })
                                return blocks.map((block, bi) => {
                                    if (block.type === 'ul') return <ul key={bi}>{block.items.map((li, li_i) => <li key={li_i}>{li}</li>)}</ul>
                                    if (block.type === 'cta') return <button key={bi} onClick={showModal} className='collapse_btn'>Request for Quotation</button>
                                    return <p key={bi}>{block.text}</p>
                                })
                            })()}
                        </Panel>
                    )
                })}
            </Collapse>

            <InfoModal
                    companyIsEnabled
                    url="http://46.101.195.121:8066/email/ContactUs"
                    isModalVisible={isModalVisible}
                    handleOk={handleOk}
                    handleCancel={handleCancel}
                />
        </div>
    )
}

export default memo(Wethoughtyoumighthavequestions)
